// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"43d24ff3","453":"635f5f07"}[chunkId] + ".chunk.js";
};